export type EnterpriseFeature = "Dashboard" | "Projects";

export const ENTERPRISE_FEATURE_COPY: Record<EnterpriseFeature, { headline: string }> = {
  Dashboard: { headline: "Dashboard is an Enterprise feature" },
  Projects: { headline: "Projects is an Enterprise feature" },
};

export interface EnterpriseInquiryTicket {
  category: string;
  subject: string;
  description: string;
  customCategory: string;
  screenshotUrl: string;
}

export const buildEnterpriseInquiryTicket = (
  feature: EnterpriseFeature,
  email: string,
  message: string,
): EnterpriseInquiryTicket => {
  const trimmedMsg = message.trim();
  const trimmedEmail = email.trim();
  return {
    category: "enterprise_inquiry",
    subject: `Enterprise interest: ${feature}`,
    description: `${trimmedMsg || "(no message)"}\nPreferred contact: ${trimmedEmail}`,
    customCategory: "",
    screenshotUrl: "",
  };
};
